// extracted by mini-css-extract-plugin
export var aiStarIcon = "_a3-4";
export var closeButton = "_a3-6";
export var dismissButton = "_a3-3";
export var editImageWithAiContainer = "_a3-8";
export var imageUploadWrapper = "_a3-7";
export var misspelledWord = "_a3-5";
export var spellCheckContainer = "_a3-2";
export var spin = "_a3-1";
export var spinning = "_a3-0";